module.exports = __webpack_public_path__ + "static/media/tv.8aede17.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mp3/tv.mp3
// module id = 3J7F
// module chunks = 1 3